import {executeQuery} from "@/main";
import pressMediaGallery from 'raw-loader!./graphql/query/pressMediaGallery.graphqls';
import pressKit from 'raw-loader!./graphql/query/pressKit.graphqls';

export default class DAMService {
    pressMediaGallery(){
        return executeQuery(null, pressMediaGallery, null)
    }
    pressKit(meetingCode){
        return executeQuery(null, pressKit, {meetingCode})
    }
}
